import PropTypes from 'prop-types';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

export const FilterPreviewer = ({
  filters,
  onFilterDismiss,
  onClearAllFilters,
  is4AcrossABVariant,
}) => {
  if (filters.length < 1) return null;

  return (
    <div className="gallery__filter-previewer">
      <div className="gallery__header-filters">
        {filters.map((f, i) => (
          <div
            className="gallery__header-filter"
            key={`filterPreviewer_filter_${i + 1}`}
            data-qa-id={`galleryHeaderFilter_${f.sectionId}_${f.filterName}`}
          >
            <Typography variant="paragraph3" classNames="gallery__filter-preview-text">
              {f.displayName}
            </Typography>
            {is4AcrossABVariant && f.sectionId === 'color' && (
              <div className={`gallery__filter-preview-color filter-color-${f.filterName}`} />
            )}
            <button
              type="button"
              aria-label="Dismiss filter"
              className="unstyled-button gallery__header__dismiss-filter-x"
              onClick={() => onFilterDismiss(f.sectionId, f.filterName, false, true)}
              data-qa-id={`galleryHeaderFilter_DismissButton_${f.sectionId}_${f.filterName}`}
            >
              <CloseLineIcon ratio={0.5} />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        aria-label="Clear all filters"
        className="unstyled-button gallery__header-clear-all-filters-link"
        onClick={onClearAllFilters}
        data-qa-id="galleryHeaderFilter_ClearAllButton"
      >
        Clear all
      </button>
    </div>
  );
};

FilterPreviewer.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      sectionId: PropTypes.string,
      filterName: PropTypes.string,
    })
  ).isRequired,
  onFilterDismiss: PropTypes.func.isRequired,
  onClearAllFilters: PropTypes.func.isRequired,
};
